
document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.querySelector('[data-ax-drawer]');
  var open = document.querySelector('[data-ax-open]');
  var close = document.querySelector('[data-ax-close]');

  if (open && drawer) open.addEventListener('click', function(){ drawer.classList.add('open'); });
  if (close && drawer) close.addEventListener('click', function(){ drawer.classList.remove('open'); });

  if (drawer) {
    drawer.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){ drawer.classList.remove('open'); });
    });
  }
});
